var map = {
	"./symbol_0.png": "b138",
	"./symbol_1.png": "4927",
	"./symbol_10.png": "9af0",
	"./symbol_2.png": "0cb9",
	"./symbol_3.png": "25b0",
	"./symbol_4.png": "d1df",
	"./symbol_5.png": "3179",
	"./symbol_6.png": "7b41",
	"./symbol_7.png": "11fc",
	"./symbol_8.png": "7103",
	"./symbol_9.png": "b3a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c652";